import { render, staticRenderFns } from "./AppliedBlocks.vue?vue&type=template&id=8321eb34&scoped=true&"
import script from "./AppliedBlocks.vue?vue&type=script&lang=js&"
export * from "./AppliedBlocks.vue?vue&type=script&lang=js&"
import style0 from "./AppliedBlocks.vue?vue&type=style&index=0&id=8321eb34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8321eb34",
  null
  
)

export default component.exports